import { render } from "./EmptyInstitutionsMessage.vue?vue&type=template&id=55a81d2c&lang=pug"
const script = {}

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__